<template>
  <div class="cs-modal-recipe">
    <div class="cs-modal-recipe__bg">
      <div class="cs-modal__padding-recipe">
        <div class="cs-modal__row-recipe cs-modal__row-1">
          <div
            class="cs-modal__col--6-6 cs-modal__close-recipe"
            style="position: absolute; top: 30px; left: 30px"
          >
            <img :src="`${pre}back.png`" class="back-img" />
          </div>
          <div class="cs-modal__col--6-6-recipe">
            <img
              :src="`${pre}photo-recipe-` + props.activeRecipe + `.png`"
              alt=""
              :class="`photo-recipe photo-recipe-` + props.activeRecipe"
              style="width: 40vw"
            />
          </div>
          <div class="cs-modal__col--6-6-recipe-2 w-100" width="100%">
            <div :class="`img--wrapper-` + props.activeRecipe">
              <img
                :src="`${pre}title-recipe-` + props.activeRecipe + `.png`"
                style="margin-top: 50px"
                :class="`title-recipe title-recipe-` + props.activeRecipe"
              />
            </div>
            <div :class="`title title-${props.activeRecipe}`">Ingredients</div>
            <div>
              <div
                class="ingredients"
                v-html="recipe[props.activeRecipe].ingredients"
              ></div>
            </div>

            <div class="title">Method</div>
            <div
              :class="`method method--${props.activeRecipe}`"
              v-html="recipe[props.activeRecipe].method"
            ></div>
            <button
              class="carousel__button"
              data-action="csWidgetOpen"
              :data-id="
                props.activeRecipe == 1
                  ? 2
                  : props.activeRecipe == 2
                  ? 2
                  : props.activeRecipe == 3
                  ? 2
                  : props.activeRecipe == 4
                  ? 2
                  : props.activeRecipe == 5
                  ? 3
                  : props.activeRecipe == 6
                  ? 1
                  : 2
              "
            >
              <img :src="`${pre}buy.png`" class="buy-btn" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import gsap from "gsap";
const props = defineProps({
  brandExperience: {
    type: String,
    default: "1",
  },
  // index of active product
  activeRecipe: {
    type: Number,
    default: 1,
  }, 
  pre: {
    type: String,
    default: "1",
  }, 
});

var recipe = {
  1: {
    ingredients:
      "50ml Captain Morgan Original Spiced Gold<br>30ml strawberry jam <br>lime juice<br>syrup<br> 1 cup of ice <br>(1.75 Units)",
    method:
      "Blend 50ml Captain Morgan Original Spiced Gold, strawberry jam, lime juice, syrup and ice together until smooth. Then pour into a fancy cocktail glass and garnish with a dollop of jam for good measure. Best enjoyed with your&nbsp;crew.",
  },
  2: {
    ingredients:
      "50ml Captain Morgan Original Spiced Gold<br>125ml cola <br>1 wedge of lime<br>cubed ice<br>(1.75 Units)",
    method:
      "Fill a tankard (or any tall glass) with plenty of ice. Measure 50ml Captain Morgan Original Spiced Gold and top with crisp cola. Stir and garnish with a fresh wedge of zingy lime. Best enjoyed with your&nbsp;crew.",
  },
  3: {
    ingredients:
      "50ml Captain Morgan Original Spiced Gold<br> 150ml lemonade <br>1 wedge of lemon  <br>cubed ice<br>(1.75 Units)",
    method:
      "Fill a tankard (or any tall glass) with plenty of ice. Pour 50ml Captain Morgan Original Spiced Gold and top with sparkling lemonade. Stir and garnish with a fresh wedge of sour lemon. Best enjoyed with your&nbsp;crew.",
  },
  4: {
    ingredients:
      "50ml Captain Morgan Original Spiced Gold <br>125ml cola<br>1 scoop of vanilla ice cream <br>cubed ice<br>(1.75 Units)",
    method:
      "Take the ice cream out of the freezer to soften for five minutes. Pour 50ml Captain Morgan Original Spiced Gold into a long glass over ice and fill ¾ with cola. Stir well, then top with a large scoop of ice cream for a smooth and sweet treat. Best enjoyed with your&nbsp;crew.",
  },
  5: {
    ingredients:
      "25ml Captain Morgan Tiki <br>200ml lemonade<br>cubed ice<br>(0.63 Units)",
    method:
      "Fill a tankard (or any tall glass) with plenty of ice. Pour 25ml Captain Morgan Tiki and top with sparkling lemonade for fizzy, fruity flavour. Best enjoyed with your&nbsp;crew.",
  },
  6: {
    ingredients:
      "50ml Captain Morgan Sliced Apple <br>50ml apple juice<br>100-150ml boiling water <br>lemon wedge <br>seasonal spices (i.e. cinnamon stick)<br>(1.25 Units)",
    method:
      "Mix 50ml Captain Morgan Sliced Apple  with apple juice in a heatproof glass or  mug. Top with boiling water and garnish with a lemon wedge or seasonal spices. Best enjoyed with your&nbsp;crew.",
  },
};
$(document).ready(function () {
  let chevronRotation = 0;
  $(document).on("click", ".carousel__button2", function () {
    //show the modal
    $(".cs-modal-recipe").css({
      display: "flex",
    });
  });
  $(document).on("click", ".cs-modal__close-recipe", function () {
    gsap.to(".cs-modal__bg", 0.25, {
      opacity: 0,
      onComplete: () => {
        gsap.set(".cs-modal__bg", {
          opacity: 1,
          delay: 0.5,
        });
      },
    });
    gsap.to(".cs-modal-recipe", {
      opacity: 0,
      delay: 0.25,
      duration: 0.5,
      onComplete: () => {
        gsap.set(".cs-modal-recipe", {
          opacity: 1,
          display: "none",
        });
      },
    });
  });
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.title {
  font-family: CaptainRoughTexture, sans-serif !important;
  font-size: 40px;
  font-weight: 100 !important;
  color: #cd0006;
  margin-bottom: 15px;
}
.ingredients {
  font-family: TradeGothic, sans-serif;
  font-size: 20px;
  font-weight: 100;
  margin-bottom: 25px;
  text-transform: none !important;
  padding-left: 200px;
  padding-right: 200px;
}
.method {
  font-family: TradeGothic, sans-serif;
  font-size: 20px;
  font-weight: 100;
  padding-left: 200px;
  padding-right: 200px;
  padding-bottom: 25px;
  text-transform: none !important;
  span {
    font-family: TradeGothic, sans-serif;
    text-transform: none;
  }
}
.carousel__button {
  padding-bottom: 25px !important;
}
.cs-modal-recipe {
  @include flexbox();
  @include align-items(center);
  @include justify-content(center);
  background: #000000;
  display: none;
  height: 100%;
  left: 0px;
  position: fixed;
  top: 0px;
  width: 100%;
  z-index: 1000;
}
.cs-modal-recipe__bg {
  background: url(/public/recipe-bg.jpg);
  z-index: 1000000;
  overflow: scroll;
  background-repeat: repeat;
  background-size: cover;
  height: 100%;
  width: 100%;
  @media screen and(max-width: $width--xs) {
    height: 100%;
    max-height: none;
    border-radius: 0px;
  }
}
.cs-modal__padding-recipe {
  @include flexbox();
  @include align-items(flex-start);
  @include justify-content(flex-start);
  @include flex-direction(column);
  height: 100%;
  width: 100%;
  @media screen and(max-width: $width--xs) {
    padding: 20px 20px 0px 20px;
  }
}
.cs-modal__row-recipe {
  @include flexbox();
  @include align-items(flex-start);
  @include justify-content(flex-start);
  width: 100%;
  @media screen and(max-width: $width--xs) {
    @include flex-direction(column);
  }
}
.cs-modal__col--6-6 {
  position: relative;
  width: 50%;
  @media screen and(max-width: $width--xs) {
    width: 100%;
  }
}
.cs-modal__row-1 {
  @media screen and(max-width: $width--xs) {
    @include flex-direction(row-reverse);
  }
  & .cs-modal__col--6-6 {
    @include flexbox();
    @include align-items(center);
    @include justify-content(flex-start);
    @media screen and(max-width: $width--xs) {
      @include justify-content(center);
    }
    &:first-child {
      @media screen and(max-width: $width--xs) {
        width: 50px;
      }
    }
    &:last-child {
      height: 50px;
    }
    & img {
      display: block;
      margin-right: 10px;
      top: 18px;
      width: 50px;
    }
  }
}
.cs-modal__close-recipe {
  position: absolute;
  top: 30px;
  &:hover {
    cursor: pointer;
  }
  @media screen and(max-width: $width--xs) {
    margin-left: 10px;
  }
  & > span {
    @media screen and(max-width: $width--xs) {
      display: none;
    }
  }
  & > img {
    @media screen and(max-width: $width--xs) {
      margin-right: 0px !important;
    }
  }
}
.cs-modal__row-2 {
  overflow: scroll;
  height: calc(100% - 50px);
  & .cs-modal__col--6-6 {
    overflow: scroll;
    height: 100%;
    &:first-child {
      @include flexbox();
      @include align-items(center);
      @include justify-content(center);
      padding-right: 30px;
      @media screen and(max-width: $width--xs) {
        padding-right: 0px;
        padding-top: 30px;
        padding-bottom: 30px;
        height: auto;
      }
    }
    &:last-child {
      @media screen and(max-width: $width--xs) {
        overflow: scroll;
      }
    }
  }
}
.cs-modal__row-1 .cs-modal__col--6-6 img {
  display: block;
  max-width: 105px;
  min-width: 90px;
}
.cs-modal__menu-recipe {
  @include flexbox();
  @include align-items(center);
  @include justify-content(flex-start);
  @include flex-direction(column);
  border-radius: 5px;
  height: 50px;
  position: absolute;
  overflow: hidden;
  width: 100%;
  z-index: 100;
  &:hover {
    cursor: pointer;
  }
  & .cs-modal__img--chevron {
    position: absolute;
    right: 0px;
    max-width: 20px;
    width: 20px;
  }
}
.cs-modal__menu-options {
  position: absolute;
}
.cs-modal__product-wrapper {
  @include flexbox();
  @include align-items(center);
  @include justify-content(center);
  font-size: 12px;
  height: 50px;
  min-height: 50px;
  padding-left: 15px;
  padding-right: 40px;
  text-align: left;
}
.cs-modal__product {
  color: #ffffff;
  font-size: 11px;
  font-weight: 700;
  line-height: 13px;
  text-align: left;
  width: 100%;
}
.cs-modal__img--product {
  width: 80px;
  @media screen and(max-width: $width--xs) {
    width: 50px;
  }
}
@media screen and(max-width: 1230px) {
  .method, .ingredients {
    padding-left: 70px !important;
    padding-right: 70px !important;
  }
}
@media screen and(max-width: 700px) {
  .cs-modal-recipe__bg {
    background: url(/public/recipe-bg-mob.jpg);
  }
  .cs-modal__col--6-6-recipe-2 {
    margin-top: -43%;
  }
  .photo-recipe {
    width: 100vw !important;
  }
  .title-recipe {
    margin-top: 0px;
    margin-bottom: 0px !important;
    width: 250px;
  }
  .title-recipe-3 {
    margin-top: 50px !important;
    margin-bottom: 20px !important;
  }
  .title-recipe-4 {
    margin-top: 70px !important;
  }
  .img--wrapper-5 {
    margin-top: 130px !important;
  }
  .img--wrapper-6 {
    margin-top: 85px !important;
  }
  .title-recipe.title-recipe-6 {
    width: 200px !important;
  }
  .title-6 {
    margin-top: 0px !important;
  }
  .serve-text-img-5 {
    width: 190px !important;
  }

  .cs-modal__row-1 {
    flex-direction: column !important;
    overflow: scroll !important;
  }
  .title {
    font-family: TradeGothic, sans-serif;
    font-weight: 400;
    font-style: normal;
    text-transform: uppercase;
    font-size: 30px !important;
    font-weight: 900;
    color: #cd0006;
  }
  .ingredients {
    font-family: TradeGothic, sans-serif !important;
    font-size: 15px !important;
    font-weight: 100;
    padding: 65px;
    padding-top: 0 !important;
    padding-bottom: 25px;
  }
  .method {
    font-family: TradeGothic, sans-serif !important;
    font-size: 15px !important;
    font-weight: 100;
    padding: 65px;
    padding-top: 0 !important;
    padding-bottom: 25px;
  }
  
  .method--6 {
    padding-left: 49px !important;
    padding-right: 49px !important;
  }
  .method--5 {
    padding-left: 38px !important;
    padding-right: 38px !important;
  }

  .cs-modal__padding-recipe {
    padding: 0 !important;
  }
}
.cs-modal__retailers {
  height: 100%;
  max-height: 100%;
  overflow: scroll;
}
.cs-modal__retailer {
  @include flexbox();
  @include align-items(center);
  @include justify-content(center);
  border-bottom: 1px solid #f0f0f0;
  height: 70px;
}
.cs-modal__retailer-logo {
  width: 70px;
}
.cs-modal__retailer-price {
  font-size: 13px;
  font-weight: 700;
  @include flex(1);
}
.cs-modal__retailer-cta {
  font-size: 10px;
  width: 80px;
}
.cs-modal__img--retailer-logo {
  display: block;
  width: 74px;
}
.cs-modal__a--retailer {
  color: #000000;
  text-decoration: none;
  &:hover {
    color: #000000;
    cursor: pointer;
    & div {
      color: #000000;
    }
  }
}
.expanded {
  overflow: scroll;
}
.back-img {
  -webkit-animation: pulse 3s linear infinite;
  animation: pulse 3s linear infinite;
}
@-webkit-keyframes pulse {
  0% {
    opacity: 1;
    transform: scale(1);
  }

  50% {
    opacity: 1;
    transform: scale(1.1);
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
